import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const mobileRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (mobileRef.current && !mobileRef.current.contains(e.target as Node)) {
        setMobileOpen(false);
      }
    }
    if (mobileOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [mobileOpen]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '电影', href: '/category/movie' },
    { label: '电视剧', href: '/category/tv' },
    { label: '动漫', href: '/category/anime' },
    { label: '综艺', href: '/category/variety' },
    { label: '关于我们', href: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-6 h-16">
        <Link
          to="/"
          className="flex items-center gap-2 font-heading text-2xl font-bold text-primary-500 whitespace-nowrap"
        >
          <i className="ri-movie-2-line text-2xl w-8 h-8 flex items-center justify-center"></i>
          <span className="hidden sm:inline">哈哈影院</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.href
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索影片..."
              className="w-48 pl-9 pr-4 py-2 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
          </div>
        </div>

        <button
          className="md:hidden p-2 rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="打开菜单"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl w-6 h-6 flex items-center justify-center`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div ref={mobileRef} className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.href
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
          <div className="mt-3 px-2">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影片..."
                className="w-full pl-9 pr-4 py-2.5 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}